import { useEffect } from 'react';

export default function useKeydown(
  cb: (evt: KeyboardEvent) => void,
  enabled: boolean = true
) {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    window.addEventListener('keydown', cb);
    return () => {
      window.removeEventListener('keydown', cb);
    };
  }, [cb, enabled]);
}
